var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M635.748 176.125L544.248 16.125C538.546 6.153 527.939 0 516.451 0H123.546C112.058 0 101.451 6.153 95.748 16.125L4.248 176.125C-7.877 197.5 7.373 224 31.998 224H63.998L64 464C64 490.51 85.49 512 112 512H336C362.51 512 384 490.51 384 464L383.998 224H527.998V488C527.998 501.2 538.798 512 551.998 512H551.998C565.198 512 575.998 501.2 575.998 488V224H607.998C632.623 224 647.873 197.5 635.748 176.125ZM335.998 464H111.998V368.25H335.998V464ZM335.998 320.25H111.998V224H335.998V320.25ZM59.623 176L132.748 48H507.248L580.248 176H59.623Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.392d7e4f9c0fd4bf690375e50a5d289f.svg";
export { ForwardRef as ReactComponent };